export default __webpack_public_path__ + "static/CameroPalanisamy-b1634ce53cfa91444c9e18a7a2ead54f.png";